import { LocationMovementsApiAdapter } from '../adapters/LocationMovementsApiAdapter';
import { LocationMovementsModel } from '../models/LocationMovements';
import { Filters } from '../models/Filters';

export interface Page {
  stockmovements: LocationMovementsModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: LocationMovementsApiAdapter) {}

  async getAllMovements(): Promise<LocationMovementsModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    this.validateFilters(filters);
    return this.apiAdapter.getLocationMovementsPaginated(filters);
  }

  async exportToExcel(filters: Filters = {}): Promise<string> {
    this.validateFilters(filters);
    return this.apiAdapter.exportToExcel(filters);
  }

  private validateFilters(filters: Filters): void {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }
  }
}
